import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../shared/services';

@Injectable({
  providedIn: 'root',
})
export class MerchantService {
  private merchant: string;
  private merchants: string[] = ['xavi-pay', 'xavi-pay-teste'];

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService
  ) {
    this.route.queryParamMap.subscribe((query) => {
      const result = query.get('m');
      if (result && this.isValidMerchant(result)) {
        this.merchant = result;
      } else {
        this.merchant = null;
      }
    });
  }

  private isValidMerchant(merchant: string): boolean {
    return this.merchants.includes(merchant);
  }

  getUserMerchant() {
    return (this.merchant = this.authService.getUserMerchant());
  }

  getLoginMerchant(tenant: string): string {
    if (this.merchant) {
      return this.merchant;
    } else if (!this.merchant && tenant) {
      this.merchant = tenant;
      return this.merchant;
    }
  }
}
